import {reverseCircle} from 'assets/images/images';
import {PrimaryButton, SecondaryButton} from 'components';
import React, {useState} from 'react';
import VersionHistory from '../modals/VersionHistory';
import EditDecision from '../modals/EditDecision';

function PreviewButtons() {
  const [versionHistoryOpen, setVersionHistoryOpen] = useState(false);
  const [editDecisionOpen, setEditDecisionOpen] = useState(false);

  const handleVersionHistoryClick = () => {
    setVersionHistoryOpen(true);
  };

  const handleEditDecisionClick = () => {
    setEditDecisionOpen(true);
  };

  return (
    <div className="flex items-center gap-2">
      <SecondaryButton
        buttonText="Version History"
        className="!h-9 flex items-center justify-center !outline-[#DFE1E7] !text-[#033971] flex-row-reverse gap-1"
        src={reverseCircle}
        onClick={handleVersionHistoryClick}
      />
      <PrimaryButton
        buttonText="Manage Decision"
        className="h-9 px-6"
        onClick={handleEditDecisionClick}
      />

      <VersionHistory
        open={versionHistoryOpen}
        setOpen={setVersionHistoryOpen}
      />
      <EditDecision open={editDecisionOpen} setOpen={setEditDecisionOpen} />
    </div>
  );
}

export default PreviewButtons;
